<template>
  <div class="mk-autoweb-article-list mk-autoweb-module">
    <div class="w1200">
      <h2>相关资讯</h2>
      <div class="mk-autoweb-article-list-content">
        <div class="mk-autoweb-article-list-content-left"><img
            src="https://mks.yybip.com/group1/M00/09/FC/CgoRC2U2RJyAOa0yABKz6LtZXRA905.png" alt=""></div>
        <div class="mk-autoweb-article-list-content-right">
          <ul>
            <li>
              <span>用友灵活用工结算方案用友灵活算方案用友灵活用工结算方案</span>
              <span>2023-10-19</span>
            </li>
            <li>
              <span>用友灵活用工结算方案用友灵活算方案用友灵活用工结算方案</span>
              <span>2023-10-19</span>
            </li>
            <li>
              <span>用友灵活用工结算方案</span>
              <span>2023-10-19</span>
            </li>
            <li>
              <span>用友灵活用工结算方案</span>
              <span>2023-10-19</span>
            </li>
            <li>
              <span>用友灵活用工结算方案</span>
              <span>2023-10-19</span>
            </li>
            <li>
              <span>用友灵活用工结算方案</span>
              <span>2023-10-19</span>
            </li>
            <li>
              <span>用友灵活用工结算方案</span>
              <span>2023-10-19</span>
            </li>
            <li>
              <span>用友灵活用工结算方案</span>
              <span>2023-10-19</span>
            </li>

          </ul>
        </div>
      </div>
      <div class="pagination-content">
        <ul id="searchPage" class="pagination-content-ul">
          <li class="active"><a title="当前是第1页">1</a></li>
          <li><a title="第2页">2</a></li>
          <li><a title="第3页">3</a></li>
          <li><a title="第4页">4</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { contentRemoteObject } from "../../../../../config/elementObject.js";
let articleObjectTemp = _.cloneDeep(contentRemoteObject);

articleObjectTemp.website_type_id = 3;
articleObjectTemp.website_type_name = '文章';
articleObjectTemp.type_id = 3;
articleObjectTemp.type_name = '文章';

export default {
  name: "MkArticleListWeb",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "图片",
          type: "image",
          width: 575,
          height: 390,
        },
        {
          code: "customField2",
          label: "内容",
          type: "content",
          contentType: 'article',
          isMultiple: true
        }
      ],
      data: {
        customField1:
          "https://mks.yybip.com/group1/M00/09/FC/CgoRC2U2RJyAOa0yABKz6LtZXRA905.png",
        customField2: articleObjectTemp
      }
    };
  },
};
</script>

<style scoped lang="scss">
.mk-autoweb-module {
  padding: .6rem
    /* 60/100 */
    0;
}

.mk-autoweb-module h2 {
  display: block;
  font-size: .3rem
    /* 30/100 */
  ;
  font-weight: bold;
  height: .4rem
    /* 40/100 */
  ;
  line-height: .3rem
    /* 30/100 */
  ;
  letter-spacing: .02rem
    /* 2/100 */
  ;
  color: #e31924;
  text-align: center;
}

.w1200 {
  width: 880px;
  margin: 0 auto;
}

.mk-autoweb-article-list-content ::-webkit-scrollbar {
  width: .08rem
    /* 8/100 */
  ;
  border-radius: .08rem
    /* 8/100 */
  ;
}

.mk-autoweb-article-list-content ::-webkit-scrollbar-track {
  background: rgba(243, 243, 243, 1);
  border-radius: .08rem
    /* 8/100 */
  ;
}

.mk-autoweb-article-list-content ::-webkit-scrollbar-thumb {
  background: #DBDBDB;
  border-radius: .08rem
    /* 8/100 */
  ;
}

.mk-autoweb-article-list-content {
  display: flex;
  height: 4.38rem
    /* 438/100 */
  ;
  padding: .2rem
    /* 20/100 */
  ;
}

.mk-autoweb-article-list-content .mk-autoweb-article-list-content-left {
  width: 50%;
  text-align: center;
  overflow: hidden;
}

.mk-autoweb-article-list-content .mk-autoweb-article-list-content-left img {
  width: 5.75rem
    /* 575/100 */
  ;
}

.mk-autoweb-article-list-content-right {
  width: 50%;
  height: 100%;
  overflow-y: scroll;
  margin-left: .3rem
    /* 30/100 */
  ;
  padding-right: .2rem
    /* 20/100 */
  ;
}

.mk-autoweb-article-list-content-right ul li {
  border-bottom: 1px solid rgba(151, 151, 151, 0.2);
  line-height: .4rem
    /* 40/100 */
  ;
}

.mk-autoweb-article-list-content-right ul li span {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mk-autoweb-article-list-content-right ul li span:first-child {
  font-size: .16rem
    /* 16/100 */
  ;
  font-weight: 500;
  color: #727272;
  font-family: PingFangSC-Medium, PingFang SC;
}

.mk-autoweb-article-list-content-right ul li span:last-child {
  font-size: .14rem
    /* 14/100 */
  ;
  color: #A0A0A0;
}

.pagination-content {
  display: flex;
  justify-content: right;
}

.pagination-content-ul {
  display: inline-block;
  padding-left: 0;
  margin: .2rem
    /* 20/100 */
    .4rem
    /* 40/100 */
    .2rem
    /* 20/100 */
    0;
  border-radius: .04rem
    /* 4/100 */
  ;
}

.pagination-content-ul li {
  display: inline;
}

.pagination-content-ul>li:first-child>a,
.pagination-content-ul>li:first-child>span {
  margin-left: 0;
  border-top-left-radius: .04rem
    /* 4/100 */
  ;
  border-bottom-left-radius: .04rem
    /* 4/100 */
  ;
}

.pagination-content-ul .active a {
  border: 1px solid #FF1616;
  background: #FFFFFF;
  border-radius: 0.06rem
    /* 6/100 */
  ;
  color: #FF1616;
}

.pagination-content-ul li a,
.pagination-content-ul li span {
  color: rgba(0, 0, 0, 0.88);
  border: none;
}

.pagination-content-ul>li>a,
.pagination-content-ul>li>span {
  position: relative;
  float: left;
  padding: .06rem
    /* 6/100 */
    .12rem
    /* 12/100 */
  ;
  margin-right: 1px;
  line-height: 1.42857143;
  color: #337ab7;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
}

.pagination-content-ul li a,
.pagination-content-ul li span {
  color: rgba(0, 0, 0, 0.88);
  border: none;
}



.pagination-content-ul .active a {
  border: 1px solid #FF1616;
  background: #FFFFFF;
  border-radius: .06rem
    /* 6/100 */
  ;
  color: #FF1616;
}

.pagination-content-ul .active a:hover {
  background: #fff;
  border: 1px solid #FF1616;
  color: #FF1616;
}

.pagination-content-ul li a:hover,
.pagination-content-ul li span:hover {
  border-radius: .06rem
    /* 6/100 */
  ;
  background: #eee;
  color: rgba(0, 0, 0, 0.88);
}
</style>
